import { render, staticRenderFns } from "./team.vue?vue&type=template&id=500dc592&scoped=true"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"
import style0 from "./team.vue?vue&type=style&index=0&id=500dc592&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500dc592",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500dc592')) {
      api.createRecord('500dc592', component.options)
    } else {
      api.reload('500dc592', component.options)
    }
    module.hot.accept("./team.vue?vue&type=template&id=500dc592&scoped=true", function () {
      api.rerender('500dc592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/attendance/setting/team.vue"
export default component.exports